'use client';

import * as React from 'react';
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

// Dynamically import the client component with SSR disabled
// This ensures the component only loads in the browser, not during server rendering
// No loading fallback - we want immediate UI display
const AppClientComponent = dynamic(
  () => import('../../../components/pages/app-page'),
  { 
    ssr: false
  }
);

export default function AppPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AppContent />
    </Suspense>
  );
}

function AppContent() {
  const searchParams = useSearchParams();
  const initialPrompt = searchParams.get('initial-prompt') || undefined;
  const fileId = searchParams.get('file-id') || undefined;
  const sampleId = searchParams.get('sample-id') || undefined;
  const source = searchParams.get('source') || undefined;

  return <AppClientComponent initialPrompt={initialPrompt} fileId={fileId} sampleId={sampleId} source={source} />;
} 